(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/coupon/coupon.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/coupon/coupon.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const CouponRow = svs.challenge.CouponRow;
const Coupon = _ref => {
  let draw = _ref.draw,
    coupon = _ref.coupon,
    history = _ref.history,
    selectedEventNumber = _ref.selectedEventNumber,
    selectItemAction = _ref.selectItemAction,
    settings = _ref.settings;
  useEffect(() => {
    const isMobile = svs.core.detect.formfactor.mobile();
    const mainContent = document.querySelector('.main-content');
    if (isMobile && mainContent) {
      mainContent.classList.add('coupon-main-content');
    }
    return () => {
      if (isMobile && mainContent) {
        mainContent.classList.remove('coupon-main-content');
      }
    };
  }, []);
  const eventRows = draw.drawEvents.map((event, i) => React.createElement(CouponRow, {
    coupon: coupon,
    draw: draw,
    event: event,
    history: history,
    isSelected: event.eventNumber === selectedEventNumber,
    key: event.eventNumber,
    nr: i + 1,
    selectItemAction: selectItemAction,
    settings: settings
  }));
  return React.createElement("ol", {
    className: "list-group list-group-default coupon-event-list margin-bottom-0"
  }, eventRows);
};
svs.challenge.Coupon = Coupon;

 })(window);